import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { TRANSLATION_BASE_URL } from "../../utils/EmpUtil";
import { getHeaders } from "../../utils/AuthorizationUtil";

export default class TranslationsClient {
  static translationUrl = TRANSLATION_BASE_URL;

  static getTranslationsLanguage(language, market, user) {
    const url = `${this.translationUrl}/translations/${language}/${market}`;
    let config = {};
    if (user) {
      config = getHeaders(user.token);
    }
    return axios
      .get(url, config)
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error.response.status);
      });
  }

  static updateCurrentTranslations(
    language,
    moduleKey,
    key,
    updatedValue,
    market,
    user
  ) {
    const url = `${this.translationUrl}/translations/${language}/${market}`;
    let config = {};
    if (user) {
      config = getHeaders(user.token);
    }
    const data = {
      moduleKey: moduleKey,
      key: key,
      changedValue: updatedValue,
    };
    return axios
      .post(url, data, config)
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error.response.status);
      });
  }

  static postAddTranslations(newTranslation, markets, user) {
    const url = `${this.translationUrl}/translations/add`;
    let config = {};
    if (user) {
      config = getHeaders(user.token);
    }
    const data = {
      moduleKey: newTranslation.moduleKey,
      key: newTranslation.key,
      en: newTranslation.en,
      fr: newTranslation.fr,
      de: newTranslation.de,
      nl: newTranslation.nl,
      no: newTranslation.no,
      es: newTranslation.es,
      it: newTranslation.it,
      fi: newTranslation.fi,
      da: newTranslation.da,
      cs: newTranslation.cs,
      pl: newTranslation.pl,
      pt: newTranslation.pt,
      el: newTranslation.el,
      ro: newTranslation.ro,
      hu: newTranslation.hu,
      markets: markets,
    };
    return axios
      .post(url, data, config)
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error.response.status);
      });
  }

  static postAddComponentTranslations(newtranslation, markets, user) {
    const url = `${this.translationUrl}/translations/add/component`;
    let config = {};
    if (user) {
      config = getHeaders(user.token);
    }
    const data = {
      moduleKey: newtranslation.moduleKey,
      key: newtranslation.key,
      en: newtranslation.en,
      fr: newtranslation.fr,
      de: newtranslation.de,
      nl: newtranslation.nl,
      no: newtranslation.no,
      es: newtranslation.es,
      it: newtranslation.it,
      fi: newtranslation.fi,
      da: newtranslation.da,
      cs: newtranslation.cs,
      pl: newtranslation.pl,
      pt: newtranslation.pt,
      el: newtranslation.el,
      ro: newtranslation.ro,
      hu: newtranslation.hu,
      markets: markets,
      pages: newtranslation.pages,
    };
    return axios
      .post(url, data, config)
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error.response.status);
      });
  }

  static getDefaultLanguage() {
    const url = `${this.translationUrl}/translations/language/`;
    return url;
  }
}
